export default "__VITE_ASSET__f96e990e__"